import type { ReactNode } from 'react'

import { ContentBriefBlockComment } from './content-brief-block-comment.atom'
import { ContentBriefBlockEditor } from './content-brief-block-editor.atom'
import { ContentBriefBlockWrapper } from './content-brief-block-wrapper.atom'
import { useContentBriefBlock } from './use-content-brief-block.hook'

export interface ContentBriefBlockProps {
  blockIndex: number
  children: ReactNode
  comment?: string
  onCommentChange: (comment: string | undefined) => void
  className?: string
}

export const ContentBriefBlock: React.FC<ContentBriefBlockProps> = ({
  blockIndex,
  children,
  comment,
  onCommentChange,
  className,
}): ReactNode => {
  const state = useContentBriefBlock({ comment, onCommentChange })

  return (
    <ContentBriefBlockWrapper
      blockIndex={blockIndex}
      isEditing={state.isEditing}
      hasComment={state.hasComment}
      onClick={state.handleBlockClick}
      onKeyDown={state.handleBlockKeyDown}
      className={className}
    >
      <div className="content-brief-block-content block min-w-0 overflow-x-auto px-2 py-1">
        {children}
      </div>

      {state.isEditing && (
        <ContentBriefBlockEditor
          draftComment={state.draftComment}
          hasComment={state.hasComment}
          textareaRef={state.textareaRef}
          onDraftChange={state.setDraftComment}
          onKeyDown={state.handleKeyDown}
          onSave={state.handleSave}
          onCancel={state.handleCancel}
          onDelete={state.handleDelete}
        />
      )}

      {comment && !state.isEditing && <ContentBriefBlockComment comment={comment} />}
    </ContentBriefBlockWrapper>
  )
}
